export { default as exploreBodyMalePNG } from '~/assets/images/anatomyV2/explore-today-body-male.png'
export { default as exploreBodyMaleWEBP } from '~/assets/images/anatomyV2/explore-today-body-male.webp'
export { default as exploreBodyFemalePNG } from '~/assets/images/anatomyV2/explore-today-body-female.png'
export { default as exploreBodyFemaleWEBP } from '~/assets/images/anatomyV2/explore-today-body-female.webp'

export const SECTION_NUMBER = 6
export const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000

export interface IExploreZone {
  key: string
  labelI18nKey: string
  width: number
  percent?: number
}

export const EXPLORE_ZONES: IExploreZone[] = [
  {
    key: 'neckPosture',
    labelI18nKey: 'onboarding.whatWeExplored.zones.neckPosture',
    width: 120,
    percent: 60,
  },
  {
    key: 'face',
    labelI18nKey: 'onboarding.whatWeExplored.zones.face',
    width: 70,
  },
  {
    key: 'heart',
    labelI18nKey: 'onboarding.whatWeExplored.zones.heart',
    width: 70,
  },
  {
    key: 'brainFocus',
    labelI18nKey: 'onboarding.whatWeExplored.zones.brainFocus',
    width: 120,
  },
  {
    key: 'spineCore',
    labelI18nKey: 'onboarding.whatWeExplored.zones.spineCore',
    width: 120,
  },
  {
    key: 'lungs',
    labelI18nKey: 'onboarding.whatWeExplored.zones.lungs',
    width: 70,
  },
  {
    key: 'organs',
    labelI18nKey: 'onboarding.whatWeExplored.zones.organs',
    width: 70,
  },
  {
    key: 'hipsPelvis',
    labelI18nKey: 'onboarding.whatWeExplored.zones.hipsPelvis',
    width: 120,
  },
  {
    key: 'feet',
    labelI18nKey: 'onboarding.whatWeExplored.zones.feet',
    width: 95,
  },
  {
    key: 'shoulders',
    labelI18nKey: 'onboarding.whatWeExplored.zones.shoulders',
    width: 95,
    percent: 20,
  },
]

export const EXPLORED_ZONES_COUNT = EXPLORE_ZONES.filter(
  (zone) => zone.percent !== undefined,
).length
